import { React, useState } from "react"; // Added useState
import { useTranslation, Trans } from "react-i18next";
import Footer from "../minicomponents/Footer";
import GeenAngstCover from "../../imgs/gallery/Releases/geenangst.jpg";
import FollowTheFireCover from "../../imgs/gallery/Releases/album_cover_300res.jpg"
const releases = [
  {
    id: 6,
    title: "Geen angst",
    releaseDate: "16-02-2026",
    image: GeenAngstCover,
    spotifyUrl: "https://open.spotify.com/track/19UGBHqkTEHr4zBxig1FH0?si=11c9057453bd44f2",
    storyKey: "releases.story1",
    defaultStory: "A song about finding peace in the midst of the storm...",
    lyrics: `Verse 1
De stilte verstikte de tafel, tranen die vloeiden als wijn
In een keer was alles veranderd. Maar God bleek dezelfde te zijn!

Verse 2
De kracht in mijn lichaam werd minder, maar U vulde mijn hart met de hoop.
Ziekte die kwam als een vonnis, maar de dood is niet wie ik geloof!

Chorus
Ik heb geen angst om te gaan. Wanneer u mij thuis haalt.
Om voor U te staan en eeuwig te loven.
Ik dans, ik dans in het licht van U.
Want U tilde mij op, U richtte mijn ogen.
Mijn ziel komt tot rust, op U mag ik hopen.
Ik dans, ik dans in het licht van U.

Tussenspel

Vers 3
Lieverds, nog 1 keer een knuffel, hou me nog eventjes vast.
Droog nu maar rustig je tranen, want straks wordt ik boven verwacht.

Chorus
Ik heb geen angst om te gaan. Wanneer u mij thuis haalt.
Om voor U te staan en eeuwig te loven.
ik dans, ik dans in het licht van U.
Want U tilde mij op, U richtte mijn ogen.
Mijn ziel komt tot rust, op U mag ik hopen.
Ik dans, ik dans in het licht bij U.

Bridge/solo
Ik laat jullie los maar ik laat je niet lopen
Jezus de enige om op te hopen

Chorus
Ik heb geen angst om te gaan. Wanneer u mij thuis haalt.
Om voor U te staan en eeuwig te loven.
ik dans, ik dans in het licht van U.
Want U tilde mij op, U richtte mijn ogen.
Mijn ziel komt tot rust, op U mag ik hopen.
Ik dans, ik dans in het licht van U.

Outro
Ik heb geen angst om te gaan. Wanneer u mij thuis haalt.
Om voor U te staan en eeuwig te loven.
ik dans, ik dans in het licht bij U.
Oh ik dans, ik dans in het licht bij u`
  },
  {
    id: 5,
    title: "What I Fear",
    releaseDate: "01-06-2026",
    image: FollowTheFireCover,
    spotifyUrl: "https://open.spotify.com/track/6UOR7a8Xwz6GYeLyNGA6oN?si=a4cd098025c04b94",
    storyKey: "releases.story2",
    defaultStory: "",
    lyrics: `Intro

Verse 1
My head under the blankets,
The light is nowhere near.
I am living in the spaces,
Between hoping and the fear.

Verse 2
If lying got me prizes,
Then I would have won them all.
To my love, my boss, my family,
With my back against the wall.

CHORUS 1
And pull up the curtains.
Let the sunlight fill my eyes. 
Wash me in the river.
Set me free from all the lies.
That's what I fear…

Intro 

Verse 3
At night I'm feeling restless.
The daytime feeling numb.
I'm walking like a zombie.
God, Save me from this song.

Bridge
Break me open, let it in. 
Let the sunlight hit my skin.
Let me see the man I've been.

Break me open, let it in. 
Let the sunlight hit my skin.
Let me see the man I've been.
Cut the lies and set me free.

Chorus 2
And pull up the curtains.
Let the sunlight fill my eyes. 
Wash me in the river.
Set me free from all the lies.

And whatever happens,
when it's time to face it all
I'm holding on to your hand
Give me strength to make the call.

Instrumental

Intro

Verse 4 outro
The clouds are slowly parting.
My loved ones standing there
The sky is far from sunny. 
But there's freedom in the air.`
  },
  {
    id: 4,
    title: "Wake up",
    releaseDate: "01-06-2026",
    image: FollowTheFireCover,
    spotifyUrl: "https://open.spotify.com/track/6h3eK73kpriDPPt74FptC1?si=89248cb2ae9c4c46",
    storyKey: "releases.story3",
    defaultStory: "",
    lyrics: `INTRO 
Stop…, listen up

VERSE 1
Wake up, It's a new day dawning.
Skies blue, I'm walking out the door.
Like I did before.

VERSE 2
Wake up, it's a new day dawning.
Wait up. Have I been here before?
What am I fighting for?

CHORUS
I've been on the road you see
Been walking carelessly
But I know, I know.
When the world's too dark to see.
There is a part in me.
That holds on strong
(That) familiar song.
Of the place where I belong.

INTERMEZZO

VERSE 3
Wake up, it's a new day calling.
Listen, I know you're feeling beat.
Get up on your feet.

VERSE 4
Wake up, it's a new day calling.
Rise up, time to hit the street.
(There's) Someone you should meet

CHORUS
I've been on the road you see
Been walking carelessly
But I know, I know.
When the world's too dark to see.
There is a part in me.
That holds on strong
(That) Familiar song.
Of the place where I belong.

SOLO

CHORUS
I've been on the road you see
Been walking carelessly
But I know, I know.
When the world's too dark to see.
There is a part in me.
That holds on strong
(That) Familiar song.
Of the place where I belong.

OUTRO`
  },
  {
    id: 3,
    title: "Prayers",
    releaseDate: "01-06-2026",
    image: FollowTheFireCover,
    spotifyUrl: "https://open.spotify.com/track/5PbEAgyJubivWLgBITIeAo?si=3333ec6de90a48dd",
    storyKey: "releases.story4",
    defaultStory: "",
    lyrics: `INTRO 

VERSE 1 Hannah
Tears are raining down the steps of your house
Empty crib still trying to figure it out.
Help me fight all the pain and the doubt
As I cry, hear me now.

VERSE 2 David
Lord, i am a man who let the lust have control
Blood on my hands, tried to cover the hole
Shame and guilt is stacking up in my soul
Oh please, forgive it all

CHORUS 1
As I, lay it down, lay it all down before you, before you
I lay it down, lay it all down before you, before you
You are the one who knows it all. Hear me pray

INTERMEZZO
Intro 4 maten.

VERSE 3 Jonah
When you said east I went straight to the west
So waves came over me and buried my chest
Still you saved me and you lay me to rest
It's all You, I confess

BRIDGE
Help me get through this night, war is going on outside and tell me what's wrong and what is right.
When i win or when i bleed, folded hands, i'm on my knees and light up whatever's left inside
You are the one who knows it all. Hear me pray
Hear me pray. 
Hear me pray oh lord

CHORUS 2
Cause i, lay it down, lay it all down before you, before you
I lay it down, lay it all down before you, before you
You are the one who knows it all. Hear me pray.`
  },
  {
    id: 2,
    title: "Home",
    releaseDate: "01-06-2026",
    image: FollowTheFireCover,
    spotifyUrl: "https://open.spotify.com/track/6tT2kbOXEvqFsmwpW2takJ?si=01eb8f2c39e844cc",
    storyKey: "releases.story5",
    defaultStory: "",
    lyrics: `INTRO 1
Knock on your door. Please let me in
I've come all this way. And i carried my sin
I'm (so) broken but I'm home

INTRO 2
My shoes are cracked. And there's holes in my purse
My stomach is aching. But my soul even worse
Father i'm broken but I'm home
It's been a long time coming, but I'm home

VERSE 1 
'Cause I was young and strong, with a bag full of money.
Didn't need nothing else, just the drinking and party's 
On my own, pay the bills, so the friends starting coming 
And you're' never alone when the waiters are running 

CHORUS 1
So i went to the city, with a bag full of cash and a heart full of dreams
And I went to the city, where the lights are burning bright and I'm just doing fine, for now.

INTRO 3 
Knock on my door
Quick, let him in
I waited so long, 
and i watched him roll in
Son you are broken, but you're home.
I've always kept on watching, now you're home. 

VERSE 2 
I saw you crawl to the door, made an end to the missing
Get your knees off the ground/floor. You're my son, you're forgiven.
Get him washed, get him changed, for the party I'm giving. 
Cause my son was dead, now he's back with the living! 

CHORUS 2
So he went to the city, with a bag full of cash and a heart full of dreams
And he went to the city, where the lights are burning bright and I'm just doing fine, for now.

For now, for now.
For now, for now, for now
For now, For now

OUTRO/BRIDGE :
Are you feeling all empty? Come home 
If your life is in pieces. Come home 
If there's nobody waiting / If there's nobody with you Come home
You know where to find me. Come home`
  },
  {
    id: 1,
    title: "Follow the fire",
    releaseDate: "01-06-2026",
    image: FollowTheFireCover,
    spotifyUrl: "https://open.spotify.com/track/5PbEAgyJubivWLgBITIeAo?si=6b29a1b7d5974924",
    storyKey: "releases.story6",
    defaultStory: "",
    lyrics: `Intro

Verse 1
When the sand is all I see
And the chariots chasing me
I'm looking for a 
way-ay out of here

Vers 2
When I'm hungry and afraid.
And my tongue is dry for days
Help me find a 
way-ay

Pre chorus
Walking down this desert road
Rising up till I can see your

Chorus 
Fire! Steps are getting lighter
When fear is gripping tighter
Your cloud is rising higher
And we follow you, we follow your fire.

Tussenspel

Vers 3
When I'm stubborn and complain.
And there no one else to blame
Still You're showing me the
way-ay

Pre chorus
Walking down this desert road
Rising up till I can see your

Chorus 
Fire! Steps are getting lighter
When fear is gripping tighter
Your cloud is rising higher
And we follow you, we follow your fire.

Bridge
Fire! Fire! Fire! Fire! 
Fire! Fire! Fire! Fire! Fire! 

Pre-chorus
Walking down this desert road
Rising up till I can see your

Chorus
Fire! Steps are getting lighter
When fear is gripping tighter
Your cloud is rising higher 

And we follow you, we follow your fire.`
  }
];

const getTrackId = (url) => {
  if (!url) return null;
  const match = url.match(/\/track\/([a-zA-Z0-9]+)/);
  return match ? match[1] : null;
};

function MusicPage() {
  const { t } = useTranslation();
  const [selectedLyrics, setSelectedLyrics] = useState(null); // Track which song's lyrics to show

  return (
    <div className="bg-gray-900 text-white min-h-screen relative">
      {selectedLyrics && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
          <div 
            className="absolute inset-0 bg-black/80 backdrop-blur-md"
            onClick={() => setSelectedLyrics(null)}
          ></div>
          
          <div className="relative bg-gray-800 border border-white/10 w-full max-w-2xl max-h-[80vh] overflow-y-auto rounded-3xl p-8 shadow-2xl animate-in fade-in zoom-in duration-300">
            <button 
              onClick={() => setSelectedLyrics(null)}
              className="absolute top-4 right-6 text-slate-400 hover:text-white text-3xl"
            >
              &times;
            </button>
            
            <h2 className="text-3xl font-bold mb-2">{selectedLyrics.title}</h2>
            <p className="text-blue-400 mb-8 font-mono tracking-widest text-sm uppercase">Lyrics</p>
            
            <pre className="whitespace-pre-wrap font-sans text-lg leading-relaxed text-slate-300 italic">
              {selectedLyrics.lyrics}
            </pre>
            
            <div className="mt-10 pt-6 border-t border-white/5">
              <button 
                onClick={() => setSelectedLyrics(null)}
                className="text-sm font-semibold text-slate-500 hover:text-white transition-colors"
              >
                {t("window.close", "CLOSE WINDOW")}
              </button>
            </div>
          </div>
        </div>
      )}

      <header className="pt-24 pb-12 px-6 text-center">
        <h1 className="alt-font text-5xl md:text-7xl font-extrabold mb-4 tracking-tight">
          {t("releases.header", "Our Music")}
        </h1>
        <p className="text-xl text-slate-400 max-w-2xl mx-auto">
          {t("releases.subheader", "Every song tells a story")}
        </p>
      </header>

      <main className="max-w-7xl mx-auto px-6 py-12">
        {[...releases]
          .sort((a, b) => {
            const parseDate = (d) => {
              const [day, month, year] = d.split("-").map(Number);
              return new Date(year, month - 1, day);
            };
            const diff = parseDate(b.releaseDate) - parseDate(a.releaseDate);
            if (diff !== 0) return diff;
            return b.id - a.id;
          })
          .map((song, index) => (
          <div 
            key={song.id} 
            className={`flex flex-col lg:flex-row items-center gap-12 mb-32 ${index % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`}
          >
            <div className="w-full lg:w-1/2">
              <div className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-lg blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
                <img 
                  src={song.image} 
                  alt={song.title} 
                  className="relative rounded-lg shadow-2xl w-full object-cover aspect-square transform group-hover:scale-[1.02] transition-transform duration-500"
                />
              </div>
            </div>

            <div className="w-full lg:w-1/2 space-y-6">
              <div>
                <span className="text-blue-400 font-mono text-sm uppercase tracking-widest">
                  {song.releaseDate}
                </span>
                <h2 className="text-4xl md:text-5xl font-bold mt-2">{song.title}</h2>
              </div>

              <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10">
                <h3 className="text-lg font-semibold mb-3 text-slate-200">Behind the Song</h3>
                <p className="text-lg leading-relaxed text-slate-400 italic">
                  <Trans i18nKey={song.storyKey} defaults={song.defaultStory} components={{ br: <br /> }}/>
                </p>
              </div>

              {getTrackId(song.spotifyUrl) && (
                <div className="pt-2">
                  <iframe
                    src={`https://open.spotify.com/embed/track/${getTrackId(song.spotifyUrl)}?utm_source=generator&theme=0`}
                    width="100%"
                    height="152"
                    frameBorder="0"
                    allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                    loading="lazy"
                    className="rounded-xl shadow-md border-0 bg-transparent"
                    title={`${song.title} Spotify player`}
                  ></iframe>
                </div>
              )}

              <div className="flex flex-wrap gap-4 pt-4">
                <a 
                  href={song.spotifyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-white text-black px-8 py-3 rounded-full font-bold hover:bg-slate-200 transition-colors"
                >
                  {t("releases.listen", "Listen now!")}
                </a>
                
                <button 
                  onClick={() => setSelectedLyrics(song)}
                  className="border border-white/20 text-white px-8 py-3 rounded-full font-bold hover:bg-white/10 transition-colors"
                >
                  {t("releases.lyrics", "View Lyrics")}
                </button>
              </div>
            </div>
          </div>
        ))}
      </main>

      <div className="mt-20">
        <Footer />
      </div>
    </div>
  );
}

export default MusicPage;